import { motion } from 'framer-motion';
import { useEffect } from 'react';
import { Link,useLocation } from 'react-router';

import OptimizedImage from '../OptimizedImage';

const HeroSection = () => {
  const location = useLocation();

  useEffect(() => {
    const state = location.state as { scrollToId?: string } | null;
    const targetId = state?.scrollToId;

    if (targetId) {
      const timer = window.setTimeout(() => {
        const element = document.getElementById(targetId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);

      return () => window.clearTimeout(timer);
    }
  }, [location.state]);

  return (
    <section id="hero" className="relative min-h-screen flex items-center bg-hero-gradient">
      <div className="container-custom grid grid-cols-1 lg:grid-cols-2 gap-12 py-16">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="flex flex-col justify-center"
        >
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-primary dark:text-theme-primary mb-6">
            <span className="block">konnect better.</span>
            <span className="block text-secondary">together.</span>
          </h1>
          <p className="text-lg md:text-xl text-theme-secondary mb-4">
            Your personal relationship coach and learning companion. Discover insights, build habits, and transform your life with evidence-based tools.
          </p>
          {/* <p className="text-base md:text-lg text-gray-600 dark:text-gray-300 mb-8">
            Every relationship has a story. Some are thriving, some are tested, and some are waiting to grow deeper. At konnect better, we give you the tools to turn those stories into something lasting, moments of clarity, connection, and joy. Practical when you need it. Inspiring when you want it. Always there when it matters most.
          </p> */}
          <div className="flex flex-col sm:flex-row gap-4">
            <motion.a
              href="/joincommunity"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="btn-primary text-center"
            >
              Join Our Community
            </motion.a>
            <Link to="/products/konnect-better-unlocking-the-power-of-your-relationships">
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="btn-secondary text-center w-full"
              >
                Buy the Book
              </motion.button>
            </Link>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="flex justify-center items-center"
        >
          <div className="relative w-full max-w-sm">
            {/* Book cover image */}
            <div className="bg-card dark:bg-panel rounded-2xl shadow-2xl p-3 aspect-[2/3] w-full overflow-hidden relative">
              <div className="rounded-xl h-full overflow-hidden">
                <OptimizedImage
                  src="/images/konnect-better-book(5).png"
                  alt="konnect better: unlocking the power of your relationships"
                  priority={true}
                  sizes="(max-width: 768px) 100vw, 50vw"
                />
              </div>
            </div>

            {/* Text-based Achievement Display */}
            {/* <motion.div
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.4 }}
              className="mt-4 space-y-2"
            >
              <a
                href="https://www.bookmarketingprofits.com/PinnacleAwardsFall2025.html"
                target="_blank"
                rel="noopener noreferrer"
                className="block text-sm font-semibold text-brand-secondary hover:text-brand-primary transition-colors duration-200"
              >
                Pinnacle Book Achievement Award Winner
              </a>
              <a
                href="https://www.amazon.com/Konnect-Better-Unlocking-Relationships-Connections/dp/B0FV14D5V1"
                target="_blank"
                rel="noopener noreferrer"
                className="block text-sm font-semibold text-brand-secondary hover:text-brand-primary transition-colors duration-200"
              >
                Amazon Best Seller
              </a>
            </motion.div> */}

            {/* Decorative elements */}
            <div className="absolute -z-10 -top-6 -right-6 w-24 h-24 bg-brand-secondary/30 rounded-full blur-xl"></div>
            <div className="absolute -z-10 -bottom-8 -left-8 w-32 h-32 bg-brand-primary/20 rounded-full blur-xl"></div>
          </div>
        </motion.div>
      </div>

      {/* Scroll indicator */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.5, duration: 1 }}
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2"
      >
        <motion.div
          animate={{ y: [0, 10, 0] }}
          transition={{ repeat: Infinity, duration: 1.5 }}
          className="flex flex-col items-center"
        >
          <p className="text-sm text-theme-secondary mb-2">Scroll to explore</p>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="text-primary dark:text-white"
          >
            <path
              d="M12 5L12 19M12 19L18 13M12 19L6 13"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </motion.div>
      </motion.div>
    </section>
  );
};

export default HeroSection;
